import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "pig"
const PigIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M7.5 9.75C8.121 9.75 8.625 10.254 8.625 10.875S8.121 12 7.5 12 6.375 11.496 6.375 10.875 6.879 9.75 7.5 9.75M14.25 9H10.5V7.5H14.25z" />
          <path
            fillRule="evenodd"
            d="M5.193 2.626C5.219 2.624 6.1 2.557 7.119 2.71 7.94 2.836 9.06 3.135 9.79 3.924 10.382 3.81 10.996 3.75 11.625 3.75 16.193 3.75 20.063 6.9 20.569 11.07Q20.65 10.959 20.72 10.838C20.863 10.578 20.953 10.293 20.986 10 21.02 9.706 20.993 9.409 20.911 9.125L22.353 8.71C22.489 9.182 22.53 9.677 22.477 10.167 22.422 10.657 22.27 11.13 22.033 11.56 21.796 11.992 21.475 12.372 21.091 12.68Q20.836 12.882 20.55 13.037C20.32 14.726 19.534 16.248 18.376 17.452V21.75H13.875V19.986C13.155 20.156 12.402 20.25 11.625 20.25 10.982 20.25 10.355 20.186 9.75 20.068V21.75H5.25V17.82C4.595 17.217 4.038 16.52 3.609 15.75H1.5V7.5H4.083Q4.28 7.222 4.5 6.959V2.679zM6 7.527 5.806 7.742Q5.422 8.168 5.114 8.652L4.895 9H3V14.25H4.535L4.74 14.675C5.147 15.52 5.743 16.282 6.486 16.912L6.75 17.137V20.25H8.25V18.097L9.219 18.392C9.975 18.622 10.783 18.75 11.625 18.75 12.596 18.75 13.523 18.581 14.374 18.28L15.375 17.922V20.25H16.875V16.825L17.105 16.604C18.366 15.389 19.125 13.769 19.125 12 19.125 8.338 15.836 5.25 11.625 5.25 10.945 5.25 10.287 5.333 9.661 5.485L9.12 5.616 8.837 5.14C8.542 4.64 7.807 4.333 6.894 4.195 6.57 4.145 6.26 4.123 6 4.114z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default PigIcon
